import { useState } from 'react';
import { FaQuestionCircle, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import styles from './FAQ.module.css';

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqItems = [
    {
      question: "¿Qué servicios de desarrollo web ofrecen?",
      answer: "Ofrecemos una amplia gama de servicios de desarrollo web, incluyendo diseño de sitios web, desarrollo de aplicaciones web, comercio electrónico, optimización SEO, y mantenimiento de sitios web. Nuestro enfoque es crear soluciones digitales personalizadas que se adapten a las necesidades específicas de cada cliente."
    },
    {
      question: "¿Cuánto tiempo toma desarrollar un sitio web?",
      answer: "El tiempo de desarrollo varía según la complejidad del proyecto. Un sitio web básico puede estar listo en 2-4 semanas, mientras que proyectos más complejos como aplicaciones web o tiendas en línea pueden tomar de 2 a 4 meses. Proporcionamos un cronograma detallado al inicio del proyecto para que conozca exactamente qué esperar."
    },
    {
      question: "¿Cuál es su proceso de trabajo?",
      answer: "Nuestro proceso de trabajo se divide en varias etapas: consulta inicial, planificación y estrategia, diseño, desarrollo, pruebas, lanzamiento y soporte posterior. Mantenemos una comunicación constante durante todo el proceso y le proporcionamos actualizaciones regulares sobre el progreso del proyecto."
    },
    {
      question: "¿Ofrecen servicios de mantenimiento después del lanzamiento?",
      answer: "Sí, ofrecemos varios planes de mantenimiento para garantizar que su sitio web permanezca actualizado, seguro y funcionando correctamente. Estos planes incluyen actualizaciones regulares, copias de seguridad, monitoreo de seguridad, y soporte técnico continuo."
    },
    {
      question: "¿Cómo puedo solicitar un presupuesto para mi proyecto?",
      answer: "Puede solicitar un presupuesto a través de nuestro formulario en línea en la sección de Presupuesto, enviándonos un correo electrónico o llamándonos directamente. Después de entender sus requisitos, le proporcionaremos un presupuesto detallado sin compromiso."
    },
    {
      question: "¿Trabajan con empresas de todos los tamaños?",
      answer: "Sí, trabajamos con empresas de todos los tamaños, desde startups y pequeñas empresas hasta grandes corporaciones. Adaptamos nuestros servicios y soluciones para satisfacer las necesidades específicas y el presupuesto de cada cliente."
    }
  ];

  return (
    <section className={styles.faqSection}>
      <div className={styles.faqContainer}>
        <div className={styles.faqHeader}>
          <div className={styles.badge}>
            <FaQuestionCircle className={styles.badgeIcon} />
            <span>Preguntas Frecuentes</span>
          </div>
          <h2>Todo lo que necesitas saber</h2>
          <p>Respuestas a las preguntas más comunes sobre nuestros servicios y proceso de trabajo</p>
        </div>

        <div className={styles.accordionContainer}>
          {faqItems.map((item, index) => (
            <div 
              key={index} 
              className={`${styles.accordionItem} ${activeIndex === index ? styles.active : ''}`}
            >
              <div 
                className={styles.accordionHeader}
                onClick={() => toggleAccordion(index)}
              >
                <h3>{item.question}</h3>
                {activeIndex === index ? 
                  <FaChevronUp className={styles.accordionIcon} /> : 
                  <FaChevronDown className={styles.accordionIcon} />
                }
              </div>
              <div className={styles.accordionContent}>
                <p>{item.answer}</p>
              </div>
            </div>
          ))}
        </div>

        <div className={styles.faqCta}>
          <p>¿No encuentras la respuesta que buscas?</p>
          <a href="/presupuesto" className={styles.ctaButton}>
            Contáctanos
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQ;